import { isEmpty, isMatch, omit } from 'lodash';

import type { SelectOption } from '@swf/components/Inputs/components/DropDown/DropDown';
import { Currency } from '@swf/core/enums';
import type { TableParams } from '@swf/generated/types/api/v0/SwHomeGames';

export interface FormValues {
  tableName: string;
  handType: string;
  potStruct: TableParams['potStruct'];
  tableSize: number;
  currency: Currency | string;
  stake: string;
  videoChatEnabled: boolean;
}

export interface OptionsFilterResponse {
  options: SelectOption[];
}

export const fallback: SelectOption[] = [];

export const getMatchingGameObject = (formState: FormValues, data: TableParams[]) => {
  const objectToMatch = {
    ...omit(formState, ['stake', 'tableName', 'videoChatEnabled']),
    ...omit(JSON.parse(`${formState.stake}`), 'id'),
    ...JSON.parse(formState.handType),
    currency: formState.currency === Currency.PlayMoney ? '' : formState.currency
  };

  if (formState.videoChatEnabled) {
    objectToMatch.videoChatSupported = true;
  }

  return data.find((item) => isMatch(item, objectToMatch));
};

export const getInitialValues = (data: TableParams[] | undefined): FormValues | undefined => {
  if (!data || isEmpty(data)) return;

  const [game] = data;
  const {
    currency,
    handType,
    potStruct,
    maxBuyIn,
    minBuyIn,
    stakesHigh,
    stakesLow,
    tableName,
    tableSize,
    hiLo
  } = game;

  return {
    stake: JSON.stringify({ id: 0, minBuyIn, maxBuyIn, stakesLow, stakesHigh }),
    currency: currency as string,
    handType: JSON.stringify({ handType, hiLo }),
    potStruct,
    tableName: tableName as string,
    tableSize: Number(tableSize),
    videoChatEnabled: false
  };
};
